import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import StartSimulation from './Pages/StartSimulation';
import ChooseOperationType from './Pages/ChooseOperationType';
import BasicInformation from './Pages/BasicInformation';
import BasicPortInformation from './Pages/BasicPortInformation'
import ComplementaryServices from './Pages/ComplementaryServices';
import FinalResult from './Pages/FinalResult';
import FinalPortResult from './Pages/FinalPortResult';
import { AnimatePresence } from 'framer-motion';
import LineupView from './Pages/Lineup/LineupView';

<link rel="stylesheet" href="https://rsms.me/inter/inter.css"></link>


export default function App() {
  const location = useLocation();
  return (
    <>
      <AnimatePresence mode="wait">
          <Routes>
            {/*<Route path='/' element={<StartSimulation />} key={location.pathname}/>*/}
            <Route path='/StartSimulation' element={<StartSimulation />} key={location.pathname}/>
            <Route path='/ChooseOperationType' element={<ChooseOperationType />} key={location.pathname} />
            <Route path='/BasicInformation' element={<BasicInformation />} key={location.pathname} />
            <Route path='/BasicPortInformation' element={<BasicPortInformation />} key={location.pathname} />
            <Route path='/ComplementaryServices' element={<ComplementaryServices />} key={location.pathname} />
            <Route path='/FinalResult' element={<FinalResult />} key={location.pathname}/>
            <Route path='/FinalPortResult' element={<FinalPortResult />} key={location.pathname}/>
            <Route path='/Lineup' element={<LineupView />} key={location.pathname}/>
          </Routes>
      </AnimatePresence >
    </>
  )
};

